import api from './api';

export const salesQuoteService = {
  async getFormData(pointOfSaleId = null) {
    const response = await api.get('/ventas/quotes/form-data', {
      params: pointOfSaleId ? { point_of_sale_id: pointOfSaleId } : undefined,
    });
    return response.data;
  },

  async getQuotes(params = {}) {
    const response = await api.get('/ventas/quotes', { params });
    return response.data;
  },

  async getPendingQuotes(pointOfSaleId) {
    const response = await api.get('/ventas/quotes/pending', {
      params: { point_of_sale_id: pointOfSaleId },
    });
    return response.data;
  },

  async getQuote(id) {
    const response = await api.get(`/ventas/quotes/${id}`);
    return response.data;
  },

  async createQuote(data) {
    const response = await api.post('/ventas/quotes', data);
    return response.data;
  },

  async updateQuote(id, data) {
    const response = await api.put(`/ventas/quotes/${id}`, data);
    return response.data;
  },

  async toggleStatus(id) {
    const response = await api.delete(`/ventas/quotes/${id}`);
    return response.data;
  },
};

export default salesQuoteService;
